import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Dialog } from "@mui/material";
import { Loader2, MessageCircle, Send, X } from "lucide-react";
import doubleCartoon from "../../../../../../assets/images/common/double-cartoon.svg";
import useSupportBoxPopup from "./hooks"

const SupportBoxPopup = ({ onClose }) => {
  const {
    isLoading,
    question,
    error,
    handleSend,
    handleClose,
    handleInputChange
  } = useSupportBoxPopup({ onClose });
  const intl = useIntl();

  return (
    <Dialog open onClose={() => { if (!isLoading) handleClose(); }} aria-labelledby="support-title" fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: "28px", backgroundColor: "transparent" } }} BackdropProps={{ sx: { backgroundColor: "rgba(255, 255, 255, 0.8)", backdropFilter: "blur(8px)" } }}>
      <form onSubmit={handleSend} className="relative bg-sky-gray p-6 sm:p-8 font-altivo tracking-normal">
        <button
          type="button"
          aria-label={intl.formatMessage({ id: "teamroom.common.close" })}
          disabled={isLoading}
          className="absolute top-5 right-5 inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/30 text-navy-blue hover:bg-white/60 transition disabled:opacity-40"
          onClick={handleClose}
        >
          <X size={18} strokeWidth={2.4} aria-hidden />
        </button>
        <div className="mb-6 pr-8">
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-[14px] bg-white/35 text-navy-blue mb-4"><MessageCircle size={21} strokeWidth={1.8} aria-hidden /></span>
          <h2 id="support-title" className="text-[22px] font-bold text-navy-blue leading-tight"><FormattedMessage id="teamroom.support.title" /></h2>
        </div>
        <label className="flex flex-col gap-2 text-[13px] font-bold text-navy-blue">
          <FormattedMessage id="teamroom.support.message" />
          <textarea
            autoFocus
            rows={6}
            disabled={isLoading}
            className="custom-scrollbar w-full min-h-[160px] max-h-[280px] resize-y rounded-[18px] border border-transparent bg-white px-4 py-3 text-[14px] font-normal leading-relaxed text-navy-blue placeholder:text-gray-400 focus:border-standart-ocean focus:ring-1 focus:ring-standart-ocean disabled:opacity-60"
            placeholder={intl.formatMessage({ id: "teamroom.support.placeholder" })}
            value={question}
            onChange={handleInputChange}
          />
        </label>
        {error && <p role="alert" className="mt-3 rounded-xl bg-white/75 px-3 py-2 text-[13px] text-red-500">{error}</p>}
        <div className="mt-5 flex items-end justify-between gap-4">
          <img src={doubleCartoon} alt="" aria-hidden className="w-24 sm:w-28 h-auto pointer-events-none" />
          <button type="submit" disabled={!question || isLoading} className="inline-flex h-11 items-center justify-center gap-2 rounded-full bg-navy-blue px-5 text-[13px] font-bold text-white hover:bg-navy-blue/90 transition disabled:opacity-40 disabled:cursor-not-allowed">
            {isLoading ? <Loader2 size={15} className="animate-spin" aria-hidden /> : <Send size={15} aria-hidden />}
            <FormattedMessage id="teamroom.support.send" />
          </button>
        </div>
      </form>
    </Dialog>
  );
};

export default SupportBoxPopup;
